import { INotificationItem } from './notificationTypes'

export const expiredSessionNotification: INotificationItem = {
    title: 'login.sessionExpired',
    kind: 'info',
    subtitle: '',
}
